import {certificateService, defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {inboxConstants, sentConstants, uriConstants, verifyConstants} from "../../constants";

export const verifyActions = {
  verifyInit,
  verifyCertificate,
  verifySentListShow,
  verifyInboxListShow
}

function apiFailure(type, response) {
  return {
    type: type,
    response
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

/*********
 증명서 진본검증 초기화
 **********/
function verifyInit() {
  return async dispatch => {
    dispatch(request())
  }

  function request() {
    return {
      type: verifyConstants.VERIFY_INIT
    }
  }
}

/*********
 증명서 진본검증
 **********/
function verifyCertificate(params) {
  return async dispatch => {
    dispatch(request())
    certificateService.verifyCertificate(params)
      .then(
        response => {
          console.log(response);
          dispatch(success(response))
        },
        error => {
          dispatch(apiFailure(verifyConstants.VERIFY_FAILURE, error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: verifyConstants.VERIFY_REQUEST
    }
  }

  function success(response) {
    return {
      type: verifyConstants.VERIFY_SUCCESS,
      response
    }
  }
}


/*********
 증명서 진본검증 대상 리스트(송신)
 **********/
function verifySentListShow(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_SENT_LIST + paramStr
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: verifyConstants.VERIFY_LIST_REQUEST
    }
  }
  function success(response) {
    return {
      type: verifyConstants.VERIFY_LIST_SENT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: verifyConstants.VERIFY_LIST_FAILURE,
      response
    }
  }
}

/*********
 증명서 진본검증 대상 리스트(수신)
 **********/
function verifyInboxListShow(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_LIST + paramStr
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: verifyConstants.VERIFY_LIST_REQUEST
    }
  }
  function success(response) {
    return {
      type: verifyConstants.VERIFY_LIST_INBOX_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: verifyConstants.VERIFY_LIST_FAILURE,
      response
    }
  }
}